"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _vue = require("@handsontable/vue");
var _vuex = require("vuex");
var _appointmentHistorySh = require("@/api/appointmentHistory/appointmentHistorySh");
var _blExchangeAppointmentSh = require("@/api/blExchangeAppointment/blExchangeAppointmentSh");
var _authorizationDialog = _interopRequireDefault(require("../blExchangeAppointment/components/authorizationDialog"));
var _batchReservation = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservation"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

"";
var _default = exports.default = {
  name: 'appointmentHistory',
  components: {
    filterColumn: _index.default,
    HotColumn: _vue.HotColumn,
    Pagination: _Pagination.default,
    sailSchedule: _SailScheduleOne.default,
    authorizationDialog: _authorizationDialog.default,
    batchReservation: _batchReservation.default
  },
  data: function data() {
    return {
      edoAccreditId: "",
      accreditBlNo: "",
      vvLBlNo: "",
      displayType: false,
      initDialogVisible: false,
      inSailScheduleDialogVisible: false,
      outSailScheduleDialogVisible: false,
      authorizationDialogVisible: false,
      tableData: [],
      formDialog: {},
      total: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        namedParameters: {}
      },
      filterForm: {
        inVesselCode: "",
        inVesselName: "",
        inVoyageNo: "",
        inVoyageLeg: "",
        outVesselCode: "",
        outVoyageNo: "",
        outVesselName: "",
        outVoyageLeg: "",
        blNo: "",
        forespeakDateStart: "",
        forespeakDateEnd: "",
        dataTime: []
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(100px)',
        width: 'auto',
        overflow: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true
      },
      paymentStatusList: [],
      forespeakStatusList: [],
      accreditStatusList: [],
      edoPaymentMethod: []
    };
  },
  created: function created() {
    var _this = this;
    this.$dictionary.get(['EDO_PAYMENT_METHOD', 'DOC_PAYMENT_STATUS', 'DOC_FORESPEAK_STATUS', 'DOC_ACCREDIT_STATUS'], true).then(function (res) {
      _this.edoPaymentMethod = res.EDO_PAYMENT_METHOD ? res.EDO_PAYMENT_METHOD : [];
      _this.paymentStatusList = res.DOC_PAYMENT_STATUS ? res.DOC_PAYMENT_STATUS : [];
      _this.forespeakStatusList = res.DOC_FORESPEAK_STATUS ? res.DOC_FORESPEAK_STATUS : [];
      _this.accreditStatusList = res.DOC_ACCREDIT_STATUS ? res.DOC_ACCREDIT_STATUS : [];
    });
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable && this.$refs.hotTable.resizeTo();
    },
    handleOpenINVessel: function handleOpenINVessel() {
      this.inSailScheduleDialogVisible = true;
    },
    handleOpenOutVessel: function handleOpenOutVessel() {
      this.outSailScheduleDialogVisible = true;
    },
    handleCloseAuthorization: function handleCloseAuthorization() {
      this.authorizationDialogVisible = false;
      this.handleSearch();
    },
    handleCloseReservation: function handleCloseReservation() {
      this.initDialogVisible = false;
      this.handleSearch();
    },
    selectionInChange: function selectionInChange(row) {
      this.inSailScheduleDialogVisible = false;
      this.filterForm.inVesselCode = row.vesselCode;
      this.filterForm.inVesselName = row.vesselName;
      this.filterForm.inVoyageNo = row.voyageNo;
      this.filterForm.inVoyageLeg = row.voyageLeg;
    },
    selectionOutChange: function selectionOutChange(row) {
      this.outSailScheduleDialogVisible = false;
      this.filterForm.outVesselCode = row.vesselCode;
      this.filterForm.outVesselName = row.vesselName;
      this.filterForm.outVoyageNo = row.voyageNo;
      this.filterForm.outVoyageLeg = row.voyageLeg;
    },
    handleReset: function handleReset() {
      for (var key in this.filterForm) {
        this.filterForm[key] = '';
      }
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 10;
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      if (this.filterForm.inVesselCode == "" && this.filterForm.inVoyageNo == "" && this.filterForm.inVoyageLeg == "" && this.filterForm.outVesselCode == "" && this.filterForm.outVoyageNo == "" && this.filterForm.outVoyageLeg == "" && this.filterForm.forespeakDateStart == "" && this.filterForm.forespeakDateEnd == "" && this.filterForm.blNo == "") {
        this.$message.error(this.$t('appointmentHistory.searchNotNull'));
        return;
      }
      this.listQuery.namedParameters = this.filterForm;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          var hot = _this2.$refs.hotTable.hotInstance;
          hot.loadData([]);
          (0, _appointmentHistorySh.searchHistory)(_this2.listQuery).then(function (res) {
            _this2.total = res.data.totalRecord;
            _this2.tableData = res.data.records;
            // if (this.tableData.length != 0) {
            //   this.hotSettings.height = 'calc(100vh - 350px)';
            // }
            if (res.data.records.length > 0) {
              _this2.hotSettings.height = 'calc(100vh - 350px)';
              _this2.resizeHotTable();
            } else {
              _this2.hotSettings.height = 'calc(100px)';
              _this2.resizeHotTable();
            }
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    handleDateRangeChange: function handleDateRangeChange(dates) {
      var _dates = (0, _slicedToArray2.default)(dates, 2),
        startDate = _dates[0],
        endDate = _dates[1];
      this.filterForm.forespeakDateStart = startDate;
      this.filterForm.forespeakDateEnd = endDate;
    },
    handleAccredit: function handleAccredit(row) {
      var _this3 = this;
      var rowData = this.$refs.hotTable.getSelected();
      //换单时间未维护不可进行授权操作
      if (!rowData.deliverableDate) {
        this.$message.error(this.$t('blExchangeAppointment.noDeliveryTime'));
        return;
      }
      //未预约不可进行授权操作
      if (!rowData.forespeakStatus) {
        this.$message.error(this.$t('blExchangeAppointment.noReservation'));
        return;
      }
      //查询出授权的数据
      this.accreditBlNo = rowData.blNo;
      this.edoAccreditId = rowData.edoAccreditId;
      if (!this.edoAccreditId) {
        this.authorizationDialogVisible = true;
      } else {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointmentSh.getForespeak)(rowData.edoAccreditId).then(function (res) {
          if (res.success) {
            _this3.formDialog = res.data;
            _this3.displayType = true;
            _this3.authorizationDialogVisible = true;
          }
        }).finally(function () {
          _this3.loading.close();
        });
      }
    },
    columnAccreditStatus: function columnAccreditStatus(instance, td, row, col, prop, value, cellProperties) {
      var _this4 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value == "1") {
        link.innerText = this.$t('blExchangeAppointment.authorized');
      } else {
        link.innerText = this.$t('blExchangeAppointment.unauthorized');
      }
      link.addEventListener('click', function () {
        return _this4.handleAccredit(row);
      });

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnAccreditSentStatus: function columnAccreditSentStatus(instance, td, row, col, prop, value, cellProperties) {
      if (value == '0') {
        td.innerHTML = this.$t('blExchangeAppointment.unSend');
      } else if (value == '1') {
        td.innerHTML = this.$t('blExchangeAppointment.send');
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnEdoSentStatus: function columnEdoSentStatus(instance, td, row, col, prop, value, cellProperties) {
      if (value == '0' || value == null) {
        td.innerHTML = this.$t('blExchangeAppointment.unSend');
      } else if (value == '1') {
        td.innerHTML = this.$t('blExchangeAppointment.send');
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnPaymentStatus: function columnPaymentStatus(instance, td, row, col, prop, value, cellProperties) {
      if (value == '0') {
        td.innerHTML = this.$t('blExchangeAppointment.noPaid');
      } else if (value == '1' || value == '2') {
        td.innerHTML = this.$t('blExchangeAppointment.accounted');
      } else if (value == '3') {
        td.innerHTML = this.$t('blExchangeAppointment.reviewingAttachment');
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    forespeakStatusRenderer: function forespeakStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
      var _this5 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value == 1) {
        link.innerText = this.$t('blExchangeAppointment.reserved');
        link.addEventListener('click', function () {
          return _this5.handleViewDetail(row);
        });
      } else if (value == 2) {
        link.innerText = this.$t('blExchangeAppointment.reservationSaved');
      } else if (value == 3) {
        link.innerText = this.$t('blExchangeAppointment.reservationFailed');
      } else {
        link.innerText = this.$t('blExchangeAppointment.notReserved');
      }
      link.addEventListener('click', function () {
        return _this5.handleViewDetail(row);
      });

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleViewDetail: function handleViewDetail(row) {
      var rowData = this.$refs.hotTable.getSelected();
      this.vvLBlNo = "VVL:".concat(rowData.outVesselCode, "/").concat(rowData.outVoyageNo).concat(rowData.outVoyageLeg, ",BL:").concat(rowData.blNo);
      this.edoAccreditId = rowData.edoAccreditId;
      this.initDialogVisible = true;
    },
    columnRendererPrintDo: function columnRendererPrintDo(instance, td, row, col, prop, value, cellProperties) {
      var _this6 = this;
      var rowData = this.tableData[row];
      if (rowData && rowData.deliveryReleaseFlag !== 1) {
        return;
      }
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      link.innerText = this.$t('com.rent.print');
      link.addEventListener('click', function () {
        (0, _appointmentHistorySh.downloadDo)(rowData.bookingHeadId).then(function (res) {
          _this6.download(res, 'downloadDo.pdf');
        });
      });
      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnRendererPrintBill: function columnRendererPrintBill(instance, td, row, col, prop, value, cellProperties) {
      var _this7 = this;
      var rowData = this.tableData[row];
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      link.innerText = this.$t('com.rent.print');
      link.addEventListener('click', function () {
        (0, _appointmentHistorySh.downloadBill)(rowData.blNo).then(function (res) {
          _this7.download(res, "".concat(rowData.blNo, ".pdf"));
        });
      });
      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnRendererPrintVoyage: function columnRendererPrintVoyage(instance, td, row, col, prop, value, cellProperties) {
      var _this8 = this;
      var rowData = this.tableData[row];
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      link.innerText = this.$t('com.rent.print');
      link.addEventListener('click', function () {
        (0, _appointmentHistorySh.downloadVoyageCertificate)(rowData.blNo).then(function (res) {
          _this8.download(res, "".concat(rowData.blNo, ".pdf"));
        });
      });
      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    download: function download(res, fileName) {
      var url = window.URL.createObjectURL(new Blob([res], {
        type: 'application/pdf'
      }));
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};